export const StorageKeys = {
    SubscriptionId: 'currentSubscriptionContext',
    CloudVendorId: 'cloudVendorId',
    CloudVendor: 'cloudVendor',
    CloudPlanProductName: 'cloudPlanProductName',
    CloudPlanId: 'cloudPlanId',
    alreadyRegistered: 'alreadyRegistered',
    email: 'email',
    email_path:'email_link'
};